import React, {Component, Fragment} from 'react';
import {translate} from 'react-i18next';
import axios from 'axios';
import config from '../../config/config';

import PageHeader from '../elements/PageHeader';
import connect from "react-redux/es/connect/connect";

class BatchActionsScreen extends Component {

    availableActions = {
        abortSupporterProjectsNoPeriodSelected: {
            additionalInfos: {
                supporterProjectState: true
            }
        },
        allowBestFriendsTicketForSupporterProjectsIfOtherProjectCheckedOutAndConfirmed: {
            additionalInfos: {
                otherProject: 'before'
            }
        },
        sendMailToSupporterProjectsBestFriendsTicketAllowedButNotSet: {},
        askSupporterProjectsForPeriodPre1ToConfirmShifts: {},
        askSupporterProjectsForPeriodPre2ToConfirmShifts: {},
        askSupporterProjectsForPeriodAfterToConfirmShifts: {},
        askSupporterProjectsForPeriodOtherToConfirmShifts: {},
        askSupporterProjectsForPeriodsPre3AndDuringToConfirmShifts: {},
        askSupporterProjectsForSelectablePeriodToConfirmShifts: {
            additionalInfos: {
                projectPeriod: 'test'
            }
        },
        kickAllSupportersNotCheckedInForPeriodPre1: {},
        recallSupportersToConfirmShifts: {},
        addBFTTokenToSupporterProjectsIfAllowedAndNotSet: {},
        rememberInvitedSupporters: {},
        setTicketToasterProvisions: {
            additionalInfos: {
                projectPeriod: 'test'
            }
        },
        setTicketsForAllSupportersWithValidStates: {},
        recreateFailedPretixTickets: {},
        setExpiresToUnsetPretixTickets: {},
        sendShiftsChanged: {
            additionalInfos: {
                projectPeriod: 'test'
            }
        },
        cancelTicketsForAbortedSupporters: {},
        sendShiftsViaEmailToSupportersForPeriod: {
            additionalInfos: {
                projectPeriod: 'test'
            }
        },
        setShiftsConfirmedConfirmedForSupporterProjectsForSelectablePeriod: {
            additionalInfos: {
                projectPeriod: 'test'
            }
        },
        cancelSupportersWithUnpaidTickets: {},
        runPeriodLottery: {},
    };

    state = {
        selectedAction: '',
        output: '',
        additionalInfos: {}
    };

    availableSupporterProjectStates = [
        'CREATED',
        'DENIED',
        'MAY_REACTIVATE',
        'MAY_REGISTRATE',
        'INVITED',
        'REACTIVATED',
        'ACCEPTED',
        'NOT_ACCEPTED',
        'CONFIRMED',
        'CHECKED_IN',
        'CHECKED_OUT',
        'ABORTED',
        'CANCELED',
        'KICKED',
        'SWITCHED'
    ];

    doAction = (doPreview) => {
        const {t} = this.props;
        this.setState({output: ''});

        let output = '';
        console.log({...this.state.additionalInfos});
        axios(`${config.server.endpoint}backend/batch/${doPreview ? 'preview/' : ''}${this.state.selectedAction}`, {
            method: doPreview ? 'post' : 'put',
            data: {...this.state.additionalInfos}
        }).then((response) => {
            if (response.status === 200) {
                output += t(`batchActions.${doPreview ? 'previewOutput' : 'output'}.result`) + '\n\n';
                output += t('batchActions.mailTemplate') + ': ' + response.data.data.mailTemplate.subject + '\n';
                output += response.data.data.mailTemplate.body + '\n\n\n';
                output += t('batchActions.supporters') + ':\n\n';
                response.data.data.affectedSupporterProjects.map((supporterProject) => (
                    output += supporterProject.firstname + ' ' + supporterProject.lastname + '\n'
                ));
                this.setState({
                    output: output
                });
            }
        });
    };

    selectAction = (actionName) => {
        this.setState({
            selectedAction: actionName,
            output: '',
            additionalInfos: {}
        })
    };

    render() {
        const {availableActions} = this;
        const {t} = this.props;
        let selectedActionData = availableActions[this.state.selectedAction];
        return (
            <div className="BatchActionsScreen">
                <PageHeader title={t('batchActions.title')}/>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group">
                                <label>
                                    {t('batchActions.selectAction.label')}
                                </label>
                                <select value={this.state.selectedAction} className="form-control" onChange={(e) => {
                                    this.selectAction(e.target.value)
                                }}>
                                    <option value="">---</option>
                                    {Object.keys(availableActions).map((aKey, aIndex) => {
                                        return (

                                            <option value={aKey} key={aIndex}>
                                                {t(`batchActions.action.${aKey}`)}
                                            </option>

                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    {selectedActionData ? (
                        <Fragment>
                            <div className="ibox m-t">
                                <div className="ibox-title">
                                    <h5>
                                        {t(`batchActions.action.${this.state.selectedAction}`)}
                                    </h5>
                                </div>
                                <div className="ibox-content">
                                    {selectedActionData.additionalInfos ? (
                                        <div className="row">
                                            <div className="col-xs-12">
                                                {selectedActionData.additionalInfos.otherProject ? (
                                                    <div className="form-group">
                                                        <label>
                                                            {t('batchActions.additionalInfos.otherProject.label')}
                                                        </label>
                                                        <select className="form-control"
                                                                onChange={(e) => this.setState({
                                                                    additionalInfos: {
                                                                        ...this.state.additionalInfos,
                                                                        otherProject: e.target.value
                                                                    }
                                                                })}
                                                                value={this.state.additionalInfos.otherProject ? this.state.additionalInfos.otherProject : ''}>
                                                            <option value="">
                                                                --- bitte auswählen ---
                                                            </option>
                                                            {this.props.availableProjects.filter((project) => !project.active).map((project, pIndex) =>
                                                                <option value={project.id}>
                                                                    {project.name}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                ) : null}
                                                {selectedActionData.additionalInfos.projectPeriod ? (
                                                    <div className="form-group">
                                                        <label>
                                                            Arbeitszeitraum
                                                        </label>
                                                        <select className="form-control"
                                                                onChange={(e) => this.setState({
                                                                    additionalInfos: {
                                                                        ...this.state.additionalInfos,
                                                                        projectPeriod: e.target.value
                                                                    }
                                                                })}
                                                                value={this.state.additionalInfos.projectPeriod ? this.state.additionalInfos.projectPeriod : ''}>
                                                            <option value="">
                                                                --- bitte auswählen ---
                                                            </option>
                                                            {this.props.selectedProject.periods.map((period, pIndex) =>
                                                                <option value={period.id} key={pIndex}>
                                                                    {period.name}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                ) : null}
                                                {selectedActionData.additionalInfos.supporterProjectState ? (
                                                  <div className="form-group">
                                                      <label>
                                                          Supporter-Status
                                                      </label>
                                                      <select className="form-control"
                                                              onChange={(e) => this.setState({
                                                                  additionalInfos: {
                                                                      ...this.state.additionalInfos,
                                                                      supporterProjectState: e.target.value
                                                                  }
                                                              })}
                                                              value={this.state.additionalInfos.supporterProjectState ? this.state.additionalInfos.supporterProjectState : ''}>
                                                          <option value="">
                                                              --- bitte auswählen ---
                                                          </option>
                                                          {this.availableSupporterProjectStates.map((supporterProjectState, spsIndex) =>
                                                            <option value={supporterProjectState} key={spsIndex}>
                                                                {supporterProjectState}
                                                            </option>
                                                          )}
                                                      </select>
                                                  </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="btn-group">
                                        <button className="btn btn-primary"
                                                onClick={() => this.doAction(true)}>
                                            {t('batchActions.previewAction')}
                                        </button>
                                        <button className="btn btn-danger"
                                                onClick={() => this.doAction(false)}>
                                            {t('batchActions.runAction')}
                                        </button>
                                    </div>
                                    {this.state.output && this.state.output.length > 0 ? (
                                        <div>
                                            <div className="hr-line-dashed"/>
                                            <pre className="pre-scrollable">
                                        {this.state.output}
                                    </pre>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </Fragment>
                    ) : null}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedProject: state.project.selectedProject,
        availableProjects: state.project.availableProjects
    }
};
export default connect(mapStateToProps, null)(translate()(BatchActionsScreen));
